import { InjectionToken } from '@angular/core';
import { WidgetDeviceInformation } from '@simOn/device/models';

export const WIDGET_COMMAND = new InjectionToken<WidgetDeviceInformation>('Widget command');
export const DEVICE_MANAGER_PATH = new InjectionToken<string>('Path to device manager');
